"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../../Grid"));
var Typography_1 = __importDefault(require("../../../Typography"));
var props_1 = require("../../context/props");
var Title = function () {
    var title = (0, props_1.usePropsContext)().title;
    if (!title)
        return null;
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, title))));
};
exports.default = Title;
